 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"framework","2":"29107295","3":"5360fe82","4":"63d58fe1","5":"d9411792fe56faceb8fca2b98b4c1aa877071e14","6":"33cd37ff3cad39a7dd71b92eb6cc0250788d1128","7":"6f9fea4874918caf08858a7bbac25b1aeb443834","8":"f8a314cfd41dd0aa780e8787e5252c04af9f8a36","9":"fc90717da69c6ef1d1031ecc3abd8c957d754dae","10":"164fa0a872ed716fd133ec29b8403483ecfe6804","11":"7298c988aaaf038da71eee78193251f6dd485726","12":"c83bf902da5c9941ac7757e7cc5c7be4fe3f0692","14":"36bcf0ca","16":"component---src-pages-404-jsx","17":"component---src-pages-authors-jsx","18":"component---src-pages-browse-jsx","19":"component---src-pages-careers-jsx","20":"component---src-pages-debt-advisor-test-tsx","21":"component---src-pages-donate-jsx","22":"component---src-pages-donations-jsx","23":"component---src-pages-fresh-starts-jsx","24":"component---src-pages-index-tsx","25":"component---src-pages-learn-jsx","26":"component---src-pages-legal-definitions-jsx","27":"component---src-pages-legalaidlocator-jsx","28":"component---src-pages-press-jsx","29":"component---src-pages-reviews-jsx","30":"component---src-pages-search-jsx","31":"component---src-pages-team-jsx","32":"component---src-pages-tools-debt-repayment-calculator-tsx","33":"component---src-pages-tools-jsx","34":"component---src-templates-author-profile-jsx","35":"component---src-templates-fresh-start-diary-jsx","36":"component---src-templates-glossary-definition-jsx","37":"component---src-templates-learn-article-tag-jsx","38":"component---src-templates-learn-article-tsx","39":"component---src-templates-page-template-tsx"}[chunkId]||chunkId) + "-" + {"0":"f508f80b194b4d56e36d","1":"3bfa673f76ed4491768b","2":"42402af61ecb67fe3eef","3":"ba7077fb817133a93386","4":"d5eaa3e43999385f2da7","5":"1c571bc71e7940d95b25","6":"a2aac0a2dd5e349f682e","7":"9373a91fa72e09f407f0","8":"eb8d184ec16b31d418b6","9":"53293e67898e80a73df8","10":"d3a559afedca246f2d65","11":"41afc24d32acc4cd6547","12":"6c87efa6935372d7c2ad","14":"249b65ec2949846a603d","16":"ad4dd898b4eaf8cd43fe","17":"093126c14c47b3a86b65","18":"bdf8ac2c224164b0942e","19":"5189dbcad9225bacf82d","20":"afb509558e1fade0a5f4","21":"1d541b3b5aa42b8ea6a8","22":"569c9cd4980e12870384","23":"9828a5bb5a47763b0af6","24":"485096863efa8d507827","25":"3de0c8607ffdddc9bbbf","26":"f708622e7b1035f6998b","27":"99716d282170c65ec152","28":"b38bb1d94b23301e9327","29":"5d9c3957708e3247b9a7","30":"6382a0c39aea3aa1d776","31":"39e35e6203fc672d7965","32":"96ab2492651cf446f194","33":"a4f7d79a8b3729bca0bd","34":"4f7fc50f7e2d0e621339","35":"1486f88a07e73b505d4a","36":"285b5938fc3eee208401","37":"d6023f47844191576453","38":"e292e2229489b7201270","39":"a45c4de233d43fa06ddb"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
